// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2143e24a","239":"1d23501f","453":"2428f281","455":"4775ca51","762":"a0dadf23"}[chunkId] + ".chunk.js";
};